import React, { useState } from 'react';
import propTypes from 'prop-types';
import { Alert, Descriptions, Modal } from 'antd';

const NewUserModal = ({ userInfo }) => {
    const [visible, setVisible] = useState(true);

    return (
        <Modal
            title="新規ユーザー"
            open={visible}
            onOk={() => setVisible(false)}
            onCancel={() => setVisible(false)}
            footer={null}
        >
            <Alert
                type="info"
                showIcon
                message="ログイン情報は新規ユーザーのメールアドレス宛に送信されました。"
                description="セキュリティ上、初期パスワードはこの画面には表示されません。本人にメールを確認するようご案内ください。"
                style={{ marginBottom: 16 }}
            />
            <Descriptions layout='vertical'>
                <Descriptions.Item label='メール' span={3}>{userInfo.email}</Descriptions.Item>
            </Descriptions>
        </Modal>
    );
};

NewUserModal.propTypes = {
    userInfo: propTypes.object
};

export default NewUserModal;
